import { rem } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Body14, Title26, Title60 } from 'components/Typography'

export const Wrapper = styled.div`
  margin: 0;
  padding: 0 40px;
  text-align: center;
`

export const Inner = styled.div`
  ${theme.mediaQueries.large} {
    margin: 0 auto;
    max-width: 1180px;
  }
`

export const Headline = styled(Title60)`
  ${theme.mediaQueries.mobile} {
    letter-spacing: -1px;
    line-height: 40px;
    margin-bottom: 50px;
  }

  ${theme.mediaQueries.large} {
    margin: 0 auto 50px;
    max-width: 780px;
  }
`

export const QR = styled.img`
  display: block;
  height: auto;
  margin: 0 auto 60px;
  width: 103px;
`

export const List = styled.ol`
  counter-reset: list-items;
  display: block;
  list-style: none outside none;
  margin: 0;
  padding: 0;
  color: ${(props) => props.theme.colors.blackToSandstone};

  ${theme.mediaQueries.large} {
    display: flex;
    flex-wrap: ${({ count }) => (count > 4 ? 'wrap' : 'nowrap')};
    justify-content: ${({ count }) => (count > 4 ? 'flex-start' : 'center')};
  }
`

export const Item = styled.li`
  counter-increment: list-items;
  display: block;
  margin: 45px 0 0;

  ${theme.mediaQueries.large} {
    flex: none;
    margin: 0;
    width: 25%;
  }

  &:first-child {
    margin-top: 0;
  }

  &:nth-child(n + 5) {
    ${theme.mediaQueries.large} {
      margin-top: 45px;
    }
  }

  &::before {
    ${(props) => props.theme.textStyles.title26}
    align-items: center;
    background: ${({ theme: { colors } }) => colors.sagelightToGreen};
    border-radius: 100%;
    content: counter(list-items, decimal-leading-zero);
    display: flex;
    font-size: ${rem(26)};
    height: 64px;
    justify-content: center;
    letter-spacing: -1.2px;
    margin: 0 auto 20px;
    padding-top: 4px;
    width: 64px;
  }
`

export const ItemHeadline = styled(Title26)`
  line-height: 36px;
  margin: 0 auto 10px;
  max-width: 260px;

  ${theme.mediaQueries.large} {
    max-width: 190px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const Desc = styled(Body14)`
  color: ${(props) => props.theme.colors.sagemedium};
  line-height: 20px;
  margin: 0 auto;

  ${theme.mediaQueries.large} {
    max-width: 255px;
  }

  br {
    ${theme.mediaQueries.mobile} {
      display: none;
    }
  }
`
